import { Menu } from "antd";
import { Route, Routes, useNavigate } from "react-router-dom";
// import ContentLayout from "../../layout/ContentLayout";
import SidebarLayout from "../../layout/SidebarLayout";
import CaregiverReview from "./CaregiverReview";

import UsageReport from "./UsageReport";

const Admin = () => {
  const items = [
    {
      label: "Usage",
      key: "usagereport",
    },
    {
      label: "Caregivers",
      key: "caregivers",
    },
  ];

  const navigate = useNavigate();

  const menuClick = (item) => {
    const { key } = item;
    navigate(key);
  };

  return (
    <>
      <div className="sub-menu">
        <Menu items={items} onClick={menuClick} mode="horizontal" />
      </div>
      <Routes>
        <Route index element={<AdminInfo />} />
        <Route path="usagereport" element={<UsageReport />} />
        <Route path="caregivers" element={<CaregiverReview />} />
      </Routes>
    </>
  );
};

const AdminInfo = () => {
  return <p>Welcome to the administration section</p>;
};

export default Admin;
